import { funds } from '@/api';
import { Toast } from 'vant';
import router from '@/router'
import QRCode from "qrcodejs2";
import { setTimeout } from 'timers';
const cashRegister = {
  state: {
    orderId: '', //订单编号
    remark: '', //取消订单备注
    qucikPaymentChannel: '', //1网上存款,2蚂蚁钱包,3转账支付
    qrcodeCanvasId: '', //二维码ID
    source: '', // ios  android 
    cancelPopupShow: false, //取消弹出Popup
    cancelCause: undefined //取消订单原因
  },
  mutations: {
    setOrderId(state, data) {
      state.orderId = data;
    },
    setQucikPaymentChannel(state, data) {
      state.qucikPaymentChannel = data;
    },
    setQrcodeCanvasId(state, data) {
      state.qrcodeCanvasId = data;
    },
    setSource(state, data) {
      state.source = data;
      if (data) {
        localStorage.setItem("cashRegisterSource", data);
      }
    },
    setCancelPopupShow(state, data) {
      state.cancelPopupShow = data;
    },
    setCancelCause(state, data) {
      state.cancelCause = data;
    },
  },
  actions: {
    //获取详情
    async getOrderDetail({ state, commit }, param = {}) {
      let loading;
      if (!param.loading) {
        loading = Toast.loading({
          duration: 0,
          mask: true,
          message: '加载中...'
        });
      }
      let data = {};
      if (!!state.orderId) {
        let res = await funds.getOrderDetail({ 'orderId': state.orderId });
        if (res.data.IsSuccess) {
          data = res.data.Data.result;
          if (!param.loading) {
            loading.clear();
          }
        } else {
          Toast.fail(res.data.Data);
        }
      }
      return data;
    },
    //确认付款
    async confirmPaid({ state, commit }, param) {
      try {
        let loading = Toast.loading({
          duration: 0,
          mask: true,
          message: '提交中...'
        });
        let res = await funds.confirmationPayment({ 'orderId': state.orderId })
        if (res.data.IsSuccess) {
          Toast({ 'mask': true, 'message': '确认订单成功！' });
          setTimeout(() => {
            router.push({
              name: 'cashRegisterStep',
              params: {
                orderid: state.orderId,
                qucikPaymentChannel: state.qucikPaymentChannel
              }
            });
          }, 3000);
        }
      } catch (err) {
        console.info(err);
      }
    },
    //打开Popup
    async cancleOrder({ state, commit }, param) {
      commit('setCancelPopupShow', true)
    },
    //取消订单
    async cancelOrderOK({ state, commit }, param) {
      try {
        let loading = Toast.loading({
          duration: 0,
          mask: true,
          message: '提交中...'
        });
        let res = await funds.userUpdateCancelOrder({ 'orderId': state.orderId, 'cancelCauses': state.cancelCause })
        if (res.data.IsSuccess) {
          Toast({ 'mask': true, 'message': '取消订单成功！' });
          setTimeout(() => {
            router.push({
              name: 'paymenttransfer'
            });
          }, 3000);
        }
        commit('setCancelPopupShow', false)
      } catch (err) {
        console.info(err);
      }
    },
    //生成二维码
    qrcodeModule({ state, commit }, param) {
      let qrcode = new QRCode(param.id, {
        width: 200, //图像宽度
        height: 200, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(param.url); //生成另一个新的二维码
      commit('setQrcodeCanvasId', param.id)
      //setImgData
    },
    //打开支付宝
    openAlipayMethod({ state, commit }, param) {
      const deviceSystem = state.source;
      if (!!deviceSystem) {
        let imgObjSrc = document.getElementById(state.qrcodeCanvasId).querySelector('canvas').toDataURL().replace('data:image/png;base64,', '');
        if (deviceSystem == 'android' && window.android.saveimage) {
          try {
            window.android.saveimage(imgObjSrc)
          } catch (e) {
            console.log(e)
          }
        } else if (deviceSystem == 'ios') {
          window.location.href = 'xinshengtouzi://saveImage?type=base64&detail=' + imgObjSrc;
        }
      }
      setTimeout(() => {
        window.location.href = 'alipayqr://platformapi/startapp'
      }, 280)
      // location.href = "alipays://platformapi/startapp";
    },
    // 返回上一页面 兼容ios 安卓
    /*    onGoBackIosAndroid({ state, commit }) {
         if (location.hash.indexOf('/funds/passageway') != -1) {
           const source = state.source;
           if (source == 'ios') {
             window.webkit.messageHandlers.upgradeGoBack.postMessage(JSON.stringify({ b: '1' }));
           } else if (source == 'android') {
             window.android.upgradeGoBack();
           }
         }
       }, */
    // 返回上一页面 兼容ios 安卓
    historyBackGo({ state, commit }, param) {
      let source = state.source;
      if (!source) {
        source = localStorage.getItem("cashRegisterSource");
        commit('setSource', source)
      }
      if (source == 'ios') {
        window.webkit.messageHandlers.upgradeGoBack.postMessage(JSON.stringify({ b: '1' }));
      } else if (source == 'android') {
        window.android.upgradeGoBack();
      }
    },
    mountedHistory({ state, dispatch, commit }, param) {
      if (window.history && window.history.pushState) {
        // 向历史记录中插入了当前页
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function() { dispatch('historyBackGo') }, false);
      }
    },
    destroyedHistory({ state, commit }, param) {
      window.removeEventListener('popstate', function() { dispatch('historyBackGo') }, false);
    }
  }
};

export default cashRegister;


// WEBPACK FOOTER //
// ./src/store/modules/cashRegister.js